module.exports = __webpack_public_path__ + "static/media/c2a-cxi-paid-mobile.6e1396f2.jpg";